<app-header></app-header>

<div class="responsive">
  <div class="container-fluid">

    <div class="row">

      <!-- Sidebar -->
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>

      <!-- Main Content -->
      <div class="col-md-9">

        <!-- Header Button -->
        <div class="mb-4 text-end">
          <button routerLink="/housing-hub/create-housing" class="btn main-backgroundcolor color">
            Create Property
          </button>
        </div>

        <!-- Skeleton Loader -->
        <div *ngIf="!loading" class="row">
          <div class="col-md-6 col-lg-4 mb-4" *ngFor="let item of [1,2,3,4]">
            <app-card-skelton title="Housing"></app-card-skelton>
          </div>
        </div>

        <!-- No Data -->
        <app-no-results-found *ngIf="loading && housingList.length === 0" title="Housing List">
        </app-no-results-found>

        <!-- Housing List -->
        <div *ngIf="loading && housingList.length > 0" class="row">

          <div class="col-md-6 col-lg-4 mb-4" *ngFor="let house of housingList">

            <div class="card shadow-sm h-100 p-3 cursor-pointer" (click)="openDetailsModal(detailsModal, house)">

              <!-- Body -->
              <div class="card-body p-2">

                <!-- Title -->
                <h5 class="mb-2">
                  {{ house.name || house.roomTitle || 'No Title' }}
                </h5>

                <!-- Price -->
                <p class="text-primary fw-bold mb-1">
                  $ {{ house.price || house.monthlyRent || 0 }}
                  <span *ngIf="house.sellStatus === 'Rent'">/month</span>
                </p>

                <!-- Type -->
                <p class="mb-1 text-muted">
                  {{ house.propertyType }} • {{ house.housingType }}
                </p>

                <!-- Beds / Baths -->
                <p class="mb-2">
                  🛏 {{ house.bedRoomCount }} |
                  🛁 {{ house.washRoomCount }} |
                  📐 {{ house.propertyArea }} {{ house.propertyUnitArea }}
                </p>

                <!-- Address -->
                <p class="text-muted small mb-2">
                  {{ house.address?.city || '' }},
                  {{ house.address?.state || '' }},
                  {{ house.address?.country || '' }}
                </p>

                <!-- Availability -->
                <p class="small mb-1">
                  📅 Available: {{ house.availableDate | date:'mediumDate' }}
                </p>

                <!-- Contact -->
                <p class="small mb-1" *ngIf="house.contactNumber">
                  📞 {{ house.contactNumber }}
                </p>

                <p class="small mb-2" *ngIf="house.email">
                  ✉️ {{ house.email }}
                </p>

                <!-- Status -->
                <span class="badge mb-2" [ngClass]="{
          'bg-success': house.status === 'Active',
          'bg-secondary': house.status !== 'Active'
        }">
                  {{ house.status }}
                </span>

              </div>

              <!-- Footer -->
              <div class="card-footer d-flex justify-content-between align-items-center">

                <small class="text-muted">
                  {{ house.createdBy?.kind }}
                </small>
                <div class="mb-4 text-end">
                  <button [routerLink]="['/housing-hub/update-housing']" [state]="{ house: house }"
                    class="btn main-backgroundcolor color">
                    Update Property
                  </button>
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</div>

<router-outlet></router-outlet>





<ng-template #detailsModal let-modal>
  <div class="modal-header custom-header">
    <div>
      <h5 class="modal-title">
        {{ selectedHouse?.roomTitle || 'Property Details' }}
      </h5>
      <small class="text-light">
        {{ selectedHouse?.address?.city }}, {{ selectedHouse?.address?.state }}
      </small>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body property-modal">

    <!-- PRICE BANNER -->
    <div class="price-banner">
      ₹ {{ selectedHouse?.price || selectedHouse?.monthlyRent }}
      <span *ngIf="selectedHouse?.sellStatus === 'Rent'">/month</span>
    </div>

    <!-- QUICK INFO -->
    <div class="info-grid">
      <div class="info-box">
        🛏 <span>{{ selectedHouse?.bedRoomCount }}</span>
        <small>Bedrooms</small>
      </div>
      <div class="info-box">
        🛁 <span>{{ selectedHouse?.washRoomCount }}</span>
        <small>Bathrooms</small>
      </div>
      <div class="info-box">
        📐 <span>{{ selectedHouse?.propertyArea }}</span>
        <small>{{ selectedHouse?.propertyUnitArea }}</small>
      </div>
    </div>

    <!-- BASIC -->
    <div class="section-card">
      <h6>🏠 Basic Information</h6>
      <p>{{ selectedHouse?.propertyType }} • {{ selectedHouse?.housingType }}</p>
      <span class="status-badge" [ngClass]="{'active': selectedHouse?.status === 'Active'}">
        {{ selectedHouse?.status }}
      </span>
    </div>

    <!-- LOCATION -->
    <div class="section-card">
      <h6>📍 Location</h6>
      <p class="fw-bold">{{ selectedHouse?.address?.googleAddress }}</p>
      <p>
        {{ selectedHouse?.address?.city }},
        {{ selectedHouse?.address?.state }},
        {{ selectedHouse?.address?.country }}
      </p>
      <p><strong>Landmark:</strong> {{ selectedHouse?.address?.landMark }}</p>
    </div>

    <!-- CONTACT -->
    <div class="section-card">
      <h6>📞 Contact Details</h6>
      <p>📞 {{ selectedHouse?.contactNumber }}</p>
      <p *ngIf="selectedHouse?.address?.alternateNo">📲 {{ selectedHouse?.address?.alternateNo }}</p>
      <p>✉️ {{ selectedHouse?.email }}</p>
      <p><strong>{{ selectedHouse?.name }}</strong></p>
    </div>

    <!-- PRICING -->
    <div class="section-card">
      <h6>💰 Pricing</h6>
      <div class="price-grid">
        <div>
          <small>Price</small>
          <p>₹ {{ selectedHouse?.price }}</p>
        </div>
        <div>
          <small>Monthly</small>
          <p>₹ {{ selectedHouse?.monthlyRent }}</p>
        </div>
        <div>
          <small>Weekly</small>
          <p>₹ {{ selectedHouse?.weeklyRent }}</p>
        </div>
      </div>
    </div>

    <!-- AMENITIES -->
    <div class="section-card">
      <h6>✨ Amenities</h6>

      <div class="chip-group">
        <span *ngFor="let a of selectedHouse?.additionalInformation?.Amenities" class="chip">
          {{ a }}
        </span>
      </div>

      <div class="chip-group mt-2">
        <span *ngFor="let f of selectedHouse?.additionalInformation?.Flooring" class="chip light">
          {{ f }}
        </span>
      </div>
    </div>

    <!-- OTHER -->
    <div class="section-card">
      <h6>📅 Availability</h6>
      <p>Available: {{ selectedHouse?.availableDate | date:'mediumDate' }}</p>
      <p>Active Till: {{ selectedHouse?.activeTill | date:'mediumDate' }}</p>
    </div>

  </div>

  <div class="modal-footer">
    <button class="btn close-btn" (click)="modal.close()">Close</button>
  </div>
</ng-template>